module.exports = __webpack_public_path__ + "static/media/talend.d4c3c7c5.png";